import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=631a9082&scoped=true&"
import script from "./activityList.vue?vue&type=script&lang=js&"
export * from "./activityList.vue?vue&type=script&lang=js&"
import style0 from "./activityList.vue?vue&type=style&index=0&id=631a9082&scoped=true&lang=scss&"
import style1 from "./activityList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a9082",
  null
  
)

component.options.__file = "activityList.vue"
export default component.exports